import axios from 'axios'
import Vapi from 'vuex-rest-api'
import Vue from 'vue'

const api = new Vapi({
  axios,
  state: {
    library: {
      materials: [],
      videos: [],
    },
    libraryReady: false,
  },
})
  .get({
    action: 'getLibrary',
    property: 'library',
    queryParams: true,
    path: '/library',
    onSuccess(s, { data }) {
      Object.keys(s.library).forEach((key) => {
        s.library[key] = []
      })
      data.forEach((item) => {
        try {
          if(!s.library[item.type]) {
            s.library[item.type] = [];
          }
          s.library[item.type].push(item)
        } catch (e) {
          console.warn(e)
        }
      })
      s.libraryReady = true
    },
  })
  .post({
    action: 'addLibrary',
    property: 'addLibraryResult',
    path: '/library',
  })
  .post({
    action: 'addLibraryToEvent',
    property: 'addLibraryToEventResult',
    path: ({ event, library }) => `/event/${event}/library/${library}`,
  })
  .delete({
    action: '_removeLibrary',
    property: 'removeLibraryResult',
    path: ({ id }) => `/library/${id}`,
  })
  .put({
    action: '_updateLibrary',
    property: 'updateLibraryResult',
    path: ({ id }) => `/library/${id}`,
  })
  .getStore({ namespaced: true })

export default {
  ...api,
  actions: {
    updateLibrary({ state, dispatch }, data) {
      dispatch('_updateLibrary', { params: data, data }).then(({data: lib}) => {
        const i = state.library.materials.findIndex(({ id }) => id === lib.id)
        if (i) {
          Vue.set(state.library.materials, i, lib)
        }
      })
    },
    removeLibrary({ state, dispatch }, ids) {
      Promise.all(ids.map((id) => dispatch('_removeLibrary', { params: { id } }))).then(() => {
        ids.forEach((idLib) => {
          const i = state.library.materials.findIndex(({ id }) => id === idLib)
          if (i) {
            Vue.delete(state.library.materials, i)
          }
        })
      })
    },
    mfcProcessing({ state, rootState, rootGetters }) {
      if (rootState.users.usersReady && state.library.materials.length) {
        let users = {}
        state.library.materials.forEach(({ user_id }, index) => {
          if (!users[user_id]) {
            users[user_id] = rootGetters['users/getUserId'](user_id)
          }
          Vue.set(state.library.materials[index], 'user', users[user_id])
        })
      }
    },
    ...api.actions,
  },
}
